import { actionGenerator, IReduxAction } from '../../../actionGenerator';
import { IUserGeo } from '../types';

export const CHANGE_USER_GEO = 'USER :: CHANGE_GEO';

export type TChangeUserGeoAction = IReduxAction<typeof CHANGE_USER_GEO, IUserGeo>;

export const changeUserGeo = actionGenerator<typeof CHANGE_USER_GEO, IUserGeo>(CHANGE_USER_GEO);
